import React, { useEffect, FC, ReactNode } from "react"
import { useAuth0 } from "@auth0/auth0-react"
import { useLocation } from "react-router-dom"
import style from "./ProtectedRoute.module.scss"
import { whiteListParams } from "./config"
import { Loader } from "../Loader"

interface ProtectedRouteProps {
  children: ReactNode
}

export const ProtectedRoute: FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading, loginWithRedirect } = useAuth0()
  const location = useLocation()

  const queryParamsUrl = location.search
  const email = new URLSearchParams(queryParamsUrl).get("email")

  const setCallbackUrlWithParams = (location: Location, params: string[]) => {
    const currentParams = params.reduce((acc: string, value: string): string => {
      const currentValue = new URLSearchParams(location.search).get(value)
      return currentValue ? acc.concat(`${acc.length === 0 ? "?" : "&"}${value}=${currentValue}`) : acc
    }, "")
    return `${location.pathname}${currentParams}`
  }

  useEffect(() => {
    if (isLoading) return

    if (!isAuthenticated) {
      const returnTo = {
        appState: {
          returnTo: setCallbackUrlWithParams(window.location, whiteListParams)
        }
      }

      const options = email ? { login_hint: email, ...returnTo } : returnTo
      loginWithRedirect(options)
    }
  }, [email, isAuthenticated, isLoading, loginWithRedirect])

  if (isLoading) {
    return (
      <div className={style.loadingPage}>
        <Loader fullPage />
      </div>
    )
  }

  if (!isAuthenticated) {
    // Return empty until Auth0 redirect happens
    return null
  }

  // ✅ Authenticated users see the protected content
  return <>{children}</>
}
